import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [1.75347045673],
    [0.03341656456, 4.66925680417, 6283.0758499914],
    [0.00034894275, 4.62610241759, 12566.1516999828],
    [0.00003497056, 2.74411800971, 5753.3848848968],
    [0.00003417571, 2.82886579606, 3.523118349],
    [0.00003135896, 3.62767041758, 77713.7714681205],
    [0.00002676218, 4.41808351397, 7860.4193924392],
    [0.00002342687, 6.13516237631, 3930.2096962196],
    [0.00001324292, 0.74246356352, 11506.7697697936],
    [0.00001273166, 2.03709655772, 529.6909650946],
    [0.00001199167, 1.10962944315, 1577.3435424478],
    [0.0000099025, 5.23268129594, 5884.9268465832],
    [0.00000901855, 2.04505443513, 26.2983197998],
    [0.00000857223, 3.50849156957, 398.1490034082],
    [0.00000779786, 1.17882652114, 5223.6939198022],
    [0.00000753141, 2.53339053818, 5507.5532386674],
    [0.00000505264, 4.58292563052, 18849.2275499742],
    [0.00000492379, 4.20506639861, 775.522611324],
    [0.00000356655, 2.91954116867, 0.0673103028],
    [0.00000317087, 5.84901952218, 11790.6290886588],
    [0.00000284125, 1.89869034186, 796.2980068164],
    [0.00000271039, 0.31488607649, 10977.078804699],
    [0.0000024281, 0.34481140906, 5486.777843175],
    [0.0000020616, 4.80646606059, 2544.3144198834],
    [0.00000205385, 1.86947813692, 5573.1428014331],
    [0.00000202261, 2.45767795458, 6069.7767545534],
    [0.00000155516, 0.83306073807, 213.299095438],
    [0.00000132212, 3.41118275555, 2942.4634232916],
    [0.00000126184, 1.0830263021, 20.7753954924],
    [0.00000115132, 0.64544911683, 0.9803210682],
    [0.00000102851, 0.63599846727, 4694.0029547076],
    [0.00000101895, 0.97569221824, 15720.8387848784],
    [0.00000101724, 4.26679821365, 7.1135470008],
    [0.00000099206, 6.20992940258, 2146.1654164752],
    [0.00000097607, 0.6810127227, 155.4203994342],
    [0.00000085803, 5.98322631256, 161000.6857376741],
    [0.00000085128, 1.29870743025, 6275.9623029906],
    [0.00000084711, 3.67080093025, 71430.69561812909],
    [0.00000079637, 1.807913307, 17260.1546546904],
    [0.00000078756, 3.03698313141, 12036.4607348882],
    [0.00000074651, 1.75508916159, 5088.6288397668],
    [0.00000073874, 3.50319443167, 3154.6870848956],
    [0.00000073547, 4.67926565481, 801.8209311238],
    [0.00000069627, 0.83297596966, 9437.762934887],
    [0.00000062449, 3.97763880587, 8827.3902698748],
    [0.00000061148, 1.81839811024, 7084.8967811152],
    [0.00000056963, 2.78430398043, 6286.5989683404],
    [0.00000056116, 4.38694880779, 14143.4952424306],
    [0.00000055577, 3.47006009062, 6279.5527316424],
    [0.00000051992, 0.18914945834, 12139.5535091068],
    [0.00000051605, 1.33282746983, 1748.016413067],
    [0.00000051145, 0.28306864501, 5856.4776591154],
    [0.00000049, 0.48735065033, 1194.4470102246],
    [0.00000041036, 5.36817351402, 8429.2412664666],
    [0.00000040938, 2.39850881707, 19651.048481098],
    [0.000000392, 6.16832995016, 10447.3878396044],
    [0.0000003677, 6.04133859347, 10213.285546211],
    [0.00000036596, 2.56955238628, 1059.3819301892],
    [0.00000035954, 1.70876111898, 2352.8661537718],
    [0.00000035566, 1.77597314691, 6812.766815086],
    [0.00000033291, 0.59309499459, 17789.845619785],
    [0.00000030412, 0.44294464135, 83996.84731811189],
    [0.00000030047, 2.73975123935, 1349.8674096588],
    [0.00000025352, 3.16470953405, 4690.4798363586],
];

const VSOP87_L1: Vsop87Element = [
    [6283.31966747491],
    [0.00206058863, 2.67823455584, 6283.0758499914],
    [0.0000430343, 2.63512650414, 12566.1516999828],
    [0.00000425264, 1.59046980729, 3.523118349],
    [0.00000119261, 5.79557487799, 26.2983197998],
    [0.00000108977, 2.96618001993, 1577.3435424478],
    [0.00000093478, 2.59212835365, 18849.2275499742],
    [0.00000072122, 1.13846158196, 529.6909650946],
    [0.00000067768, 1.87472304791, 398.1490034082],
    [0.00000067327, 4.40918235168, 5507.5532386674],
    [0.00000059027, 2.8879703846, 5223.6939198022],
    [0.00000055976, 2.17471680261, 155.4203994342],
    [0.00000045407, 0.39803079805, 796.2980068164],
    [0.00000036369, 0.46624739835, 775.522611324],
    [0.00000028958, 2.64707383882, 7.1135470008],
    [0.00000020844, 5.34138275149, 0.9803210682],
    [0.00000019097, 1.84628332577, 5486.777843175],
    [0.00000018508, 4.96855124577, 213.299095438],
    [0.00000017293, 2.99116864949, 6275.9623029906],
    [0.00000016233, 0.03216483047, 2544.3144198834],
    [0.00000015832, 1.43049285325, 2146.1654164752],
    [0.00000014615, 1.20532366323, 10977.078804699],
    [0.00000012461, 2.83432285512, 1748.016413067],
    [0.00000011877, 3.25804815607, 5088.6288397668],
    [0.00000011808, 5.2737979048, 1194.4470102246],
    [0.00000011514, 2.07502418155, 4694.0029547076],
    [0.00000010641, 0.76614199202, 553.5694028424],
    [0.00000009969, 1.30262991097, 6286.5989683404],
    [0.00000009721, 4.23925472239, 1349.8674096588],
    [0.00000009452, 2.69957062864, 242.728603974],
    [0.00000008577, 5.64475868067, 951.7184062506],
    [0.00000007576, 5.30062664886, 2352.8661537718],
    [0.00000006385, 2.65033984967, 9437.762934887],
    [0.00000006101, 4.66632584188, 4690.4798363586],
];

const VSOP87_L2: Vsop87Element = [
    [0.0005291887],
    [0.00008719837, 1.07209665242, 6283.0758499914],
    [0.00000309125, 0.86728818832, 12566.1516999828],
    [0.00000027339, 0.05297871691, 3.523118349],
    [0.00000016334, 5.18826691036, 26.2983197998],
    [0.00000015752, 3.6845788943, 155.4203994342],
    [0.00000009541, 0.75742297675, 18849.2275499742],
    [0.00000008937, 2.05705419118, 77713.7714681205],
    [0.00000006952, 0.8267330541, 775.522611324],
    [0.00000005064, 4.66284525271, 1577.3435424478],
    [0.00000004061, 1.03057162962, 7.1135470008],
    [0.0000000381, 3.4405080349, 5573.1428014331],
    [0.00000003463, 5.14074632811, 796.2980068164],
    [0.00000003169, 6.05291851171, 5507.5532386674],
    [0.0000000302, 1.19246506441, 242.728603974],
    [0.00000002886, 6.11652627155, 529.6909650946],
    [0.00000002714, 0.30637881025, 398.1490034082],
    [0.00000002538, 2.27992810679, 553.5694028424],
    [0.00000002371, 4.38118838167, 5223.6939198022],
    [0.00000002079, 3.75435330484, 0.9803210682],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000289226, 5.84384198723, 6283.0758499914],
    [0.00000034955],
    [0.00000016819, 5.48766912348, 12566.1516999828],
    [0.00000002962, 5.19577265202, 155.4203994342],
    [0.00000001288, 4.72200252235, 3.523118349],
    [0.00000000714, 5.30045809128, 18849.2275499742],
    [0.00000000635, 5.96925937141, 242.728603974],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000007717, 4.13446589358, 6283.0758499914],
    [0.00000000765, 3.83803776214, 12566.1516999828],
    [0.0000000042, 0.41925861858, 155.4203994342],
];

const VSOP87_L5: Vsop87Element = [[0.00000000172, 2.7657906951, 6283.0758499914]];

const VSOP87_B0: Vsop87Element = [
    [0.0000027962, 3.19870156017, 84334.66158130829],
    [0.00000101643, 5.42248619256, 5507.5532386674],
    [0.00000080445, 3.88013204458, 5223.6939198022],
    [0.00000043806, 3.70444689758, 2352.8661537718],
    [0.00000031933, 4.00026369781, 1577.3435424478],
];

const VSOP87_B1: Vsop87Element = [
    [0.0000000903, 3.8972906189, 5507.5532386674],
    [0.00000006177, 1.73038850355, 5223.6939198022],
];

const VSOP87_B2: Vsop87Element = [];

const VSOP87_B3: Vsop87Element = [];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [1.00013988799],
    [0.01670699626, 3.09846350771, 6283.0758499914],
    [0.00013956023, 3.0552460962, 12566.1516999828],
    [0.0000308372, 5.19846674381, 77713.7714681205],
    [0.00001628461, 1.17387749012, 5753.3848848968],
    [0.00001575568, 2.84685245825, 7860.4193924392],
    [0.00000924799, 5.45292234084, 11506.7697697936],
    [0.00000542444, 4.56409149777, 3930.2096962196],
    [0.0000047211, 3.66100022149, 5884.9268465832],
    [0.00000345983, 0.96368617687, 5507.5532386674],
    [0.0000032878, 5.89983646482, 5223.6939198022],
    [0.00000306784, 0.29867139512, 5573.1428014331],
    [0.00000243189, 4.27349536153, 11790.6290886588],
    [0.00000211829, 5.84714540314, 1577.3435424478],
    [0.00000185752, 5.02194447178, 10977.078804699],
    [0.00000174844, 3.01193636534, 18849.2275499742],
    [0.00000109835, 5.05510636285, 5486.777843175],
    [0.00000098316, 0.88681311277, 6069.7767545534],
    [0.00000086499, 5.68959778254, 15720.8387848784],
    [0.00000085825, 1.27083733351, 161000.6857376741],
    [0.00000064903, 0.27250613787, 17260.1546546904],
    [0.00000062916, 0.92177108832, 529.6909650946],
    [0.00000057056, 2.01374292014, 83996.84731811189],
    [0.00000055736, 5.24159798933, 71430.69561812909],
    [0.00000049384, 3.24501240359, 2544.3144198834],
    [0.00000046963, 2.57805070386, 775.522611324],
    [0.00000044661, 5.53715807302, 9437.762934887],
    [0.00000042515, 6.01110242003, 6275.9623029906],
    [0.00000038968, 5.36071738169, 4694.0029547076],
    [0.00000038245, 2.39255343974, 8827.3902698748],
    [0.0000003749, 0.82952922332, 19651.048481098],
    [0.00000036957, 4.90107591914, 12139.5535091068],
    [0.0000003566, 1.67468058995, 12036.4607348882],
    [0.00000034537, 1.84270693282, 2942.4634232916],
    [0.00000033193, 0.24370300098, 7084.8967811152],
    [0.00000031921, 0.18368229781, 5088.6288397668],
    [0.00000031846, 1.77775642085, 398.1490034082],
    [0.00000028464, 1.21344868176, 6286.5989683404],
    [0.00000027793, 1.89934330904, 6279.5527316424],
    [0.00000026275, 4.58896850401, 10447.3878396044],
];

const VSOP87_R1: Vsop87Element = [
    [0.00103018608, 1.10748969588, 6283.0758499914],
    [0.00001721238, 1.06442301418, 12566.1516999828],
    [0.00000032346, 1.02169059149, 18849.2275499742],
    [0.00000030799, 2.84353804832, 5507.5532386674],
    [0.00000024971, 1.31906709482, 5223.6939198022],
    [0.00000018485, 1.42429748614, 1577.3435424478],
    [0.00000010078, 5.91378194648, 10977.078804699],
    [0.00000008654, 1.42046854427, 6275.9623029906],
    [0.00000008634, 0.27146150602, 5486.777843175],
    [0.00000005069, 1.68613426734, 5088.6288397668],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004359385, 5.78455133738, 6283.0758499914],
    [0.00000123633, 5.57934722157, 12566.1516999828],
    [0.00000008792, 3.62777733395, 77713.7714681205],
    [0.00000005689, 1.86958905084, 5573.1428014331],
    [0.00000003301, 5.47027913302, 18849.2275499742],
    [0.00000001471, 4.48028885617, 5507.5532386674],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000144595, 4.27319435148, 6283.0758499914],
    [0.00000006729, 3.91697608662, 12566.1516999828],
];

const VSOP87_R4: Vsop87Element = [[0.00000003858, 2.56384387339, 6283.0758499914]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
